import React, { useEffect, useState, useContext } from "react";
import { io } from "socket.io-client";
import { Context } from "../../../../utils/context";
import "./Instruments.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";

const InstrumentSocket = ({
  item,
  latestClose,
  onSelect,
  onClose,
  latestBaseCloses,
}) => {
  const { IMG_URL } = useContext(Context);

  const isPriceDown =
    Number(item?.Company?.charts?.[0]?.Close) > Number(latestClose);

  return (
    <tr
      onClick={() => {
        onSelect(item.id, item.name);
      }}
      style={{ cursor: "pointer" }}
    >
      <td>
        <img
          src={IMG_URL + item.logo}
          alt={item.symbol}
          className="symbol_icon"
        />{" "}
        {item.name}
      </td>
      <td className={isPriceDown ? "text-red-500" : "text-green-500"}>
        {latestClose}
      </td>
      <td>
        <span
          className={`signal_icon ${isPriceDown ? "signal_down" : "signal_up"}`}
        >
          <FontAwesomeIcon
            className="icon"
            icon={isPriceDown ? faArrowDown : faArrowUp}
          />
        </span>
      </td>
    </tr>
  );
};

export default InstrumentSocket;
